import styled, { css } from 'styled-components'
import { truncateStyles, ButtonUnstyled } from '@sketch/components'
import checkerboardBackground from '@sketch/icons/inspector/checkboard-background.svg'
import { ReactComponent as Rectangles } from '@sketch/icons/rectangles-2-17'
import { ReactComponent as ColorFanIcon } from '@sketch/icons/color-fan-17'

const iconStyles = css`
  width: 17px;
  height: 17px;
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
`

export const Stops = styled.div`
  padding: 18px 20px; /* stylelint-disable-line scales/space */
  width: 300px;
`

export const StopContainer = styled.div<{ connected: boolean }>`
  display: flex;
  width: 100%;
  ${({ connected }) =>
    connected &&
    css`
      padding-bottom: 16px;
    `}

  .ColorText {
    width: 165px;
    ${truncateStyles};
  }
`

//making sure the button is aligned with the text
export const PopoverButtonContainer = styled.div`
  margin-top: -5px; /* stylelint-disable-line scales/space */
`

export const StopPercentage = styled.div`
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
  font-size: 0.8125rem;
  margin-right: 8px;
  text-align: right;
  width: 34px;
  min-width: 34px;
`

export const CopyAll = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.D};
  margin-top: 20px;

  button {
    color: ${({ theme }) => theme.colors.foreground.secondary.B};
  }
`

export const SwatchContainer = styled.div`
  margin-top: 16px;
  margin-bottom: 12px;
  width: 300px;
  height: 148px;
  position: relative;
`

export const SwatchBackground = styled.div`
  position: absolute;
  inset: 0;
  background-image: url(${checkerboardBackground});
  background-size: 8px;
`

export const ColorSwatch = styled.div<{
  background: string
}>(
  ({ theme, background }) => css`
    position: absolute;
    inset: 0;
    box-shadow:
      0 -1px 0 0 inset ${theme.colors.border.A},
      0 1px 0 0 inset ${theme.colors.border.A};

    background: ${background};
  `
)

export const CopyIcon = styled(Rectangles)`
  ${iconStyles}
`

export const CopyButton = styled(ButtonUnstyled)`
  ${iconStyles}
`

export const ColorDropdownIcon = styled(ColorFanIcon)`
  ${iconStyles}
`

export const ColorDropdownToggle = styled(ButtonUnstyled)`
  ${iconStyles};
  margin-left: 8px;
  margin-top: 4px;
`

export const ColorSpaceValue = styled.div`
  margin-left: 96px; /* stylelint-disable-line scales/space */
  font-size: ${({ theme }) => theme.fontSizes.D};
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
  padding: 4px 0;
`
